import React, { createContext, useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Element, Link as ScrollLink } from 'react-scroll';
import {
  FaHome,
  FaGraduationCap,
  FaCode,
  FaBriefcase,
  FaEnvelope,
  FaProjectDiagram,
} from 'react-icons/fa';
import Education from './components/Education';
import TechSkills from './components/TechSkills';
import Contact from './components/Contact';
import Home from './components/Home';
import Projects from './components/Projects';
import Experiences from './components/Experiences';
import { useMediaQuery } from 'react-responsive';

export const NavHeightContext = createContext();

const App = () => {
  const navRef = useRef(null);
  const [navHeight, setNavHeight] = useState(0);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    const handleResize = () => {
      setNavHeight(navRef.current.offsetHeight);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      <nav style={styles.nav} ref={navRef}>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <ScrollLink
              to='home'
              smooth={true}
              duration={500}
              style={styles.scrollLink}
            >
              <FaHome /> {isMobile ? null : 'Home'}
            </ScrollLink>
          </li>
          <li style={styles.li}>
            <ScrollLink
              to='education'
              smooth={true}
              duration={500}
              style={styles.scrollLink}
            >
              <FaGraduationCap /> {isMobile ? null : 'Education'}
            </ScrollLink>
          </li>
          <li style={styles.li}>
            <ScrollLink
              to='tech-skills'
              smooth={true}
              duration={500}
              style={styles.scrollLink}
            >
              <FaCode /> {isMobile ? null : 'Tech Skills'}
            </ScrollLink>
          </li>
          <li style={styles.li}>
            <ScrollLink
              to='experience'
              smooth={true}
              duration={500}
              style={styles.scrollLink}
            >
              <FaBriefcase /> {isMobile ? null : 'Experience'}
            </ScrollLink>
          </li>
          <li style={styles.li}>
            <ScrollLink
              to='project'
              smooth={true}
              duration={500}
              style={styles.scrollLink}
            >
              <FaProjectDiagram /> {isMobile ? null : 'Project'}
            </ScrollLink>
          </li>
          <li style={styles.li}>
            <ScrollLink
              to='contact'
              smooth={true}
              duration={500}
              style={styles.scrollLink}
            >
              <FaEnvelope /> {isMobile ? null : 'Contact'}
            </ScrollLink>
          </li>
        </ul>
      </nav>

      <NavHeightContext.Provider value={navHeight}>
        <main style={styles.main}>
          <Element name='home'>
            <Home />
          </Element>
          {/* <Element name='newHome'>
            <NewHome />
          </Element> */}
          <Element name='education'>
            <Education />
          </Element>
          <Element name='tech-skills'>
            <TechSkills />
          </Element>
          <Element name='experience'>
            <Experiences />
          </Element>
          <Element name='project'>
            <Projects />
          </Element>
          <Element name='contact'>
            <Contact />
          </Element>
        </main>
      </NavHeightContext.Provider>
    </Router>
  );
};

const styles = {
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    // backgroundColor: 'rgba(250, 250, 252, 0.8)', /* Transparent background */
    padding: '10px',
    // height: '20px',
    // backgroundColor: '#faf9fb',
    // opacity: 0.3, //makes entire nav to get opacity
    backgroundColor: 'rgba(250, 249, 251, 0.95)', //#faf9fb
    zIndex: 4,
  },
  ul: {
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0',
    padding: '0',
  },
  li: {
    marginRight: '10px' /* Adjust spacing between list items */,
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
  scrollLink: {
    textDecoration: 'none',
    color: 'black',
    cursor: 'pointer',
  },
  main: {
    marginTop: 'var(--nav-height)',
  },
};

export default App;
